import React, { useCallback, useState } from 'react'
import { Box, Accordion, AccordionSummary, AccordionDetails, Theme, useMediaQuery, Grid, Button } from '@mui/material'
import { makeStyles } from '@mui/styles'
import * as ls from 'local-storage'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { propsAction } from '../../../store/props'
import { showCheckList } from '../../../api'
import { modalsAction } from '../../../store/modals'
import { ModerThreeAccessStageModal } from '../modals/three-access-stage'
import { Checklist, N2Approves, RequestsApproves } from '../../../types/default-types'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

export const ThreeAccessStage: React.FC<{
  img: any
  data: any
  stage: number
  className: any
  expanded: boolean
  updateInfo(): void
  onExpand: () => void
  openCheckList: () => void
}> = ({
  data = [],
  className,
  expanded,
  img = [],
  updateInfo,
  stage,
  onExpand = () => {},
  openCheckList = () => {},
}): JSX.Element => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))
  const md = useMediaQuery(({ breakpoints: { down } }: Theme) => down(960))

  const [checkListsTwoSub, setCheckListsTwoSub] = useState<any>({})
  const [moderThreeAccessStageModal, setModerThreeAccessStageModal] = useState<boolean>(false)
  const [confirm, setConfirm] = useState<any>({
    data: undefined,
    request: undefined,
    type: undefined,
  })

  const [disabledBtn, setDisabledBtn] = useState<boolean>(false)

  const handleChangeExAccessStage = () => {
    onExpand()
    setCheckListsTwoSub({})
  }

  const handleChangeExCheckListsTwoSub = (id: number, show: boolean) => {
    setCheckListsTwoSub({ ...checkListsTwoSub, [id]: show })
  }

  const loadCheckLists = useCallback((index: number, indexSub: number, indexCheck) => {
    setDisabledBtn(true)
    openCheckList()
    let checklist_all = {
      loaded: true,
      employee: undefined,
      checklist: undefined,
    }

    dispatch(propsAction.setProps({ checklist_all }))

    showCheckList({ checklistId: data[index].requests[indexSub].checklists[indexCheck].id })
      .then((res) => {
        if (res.status === 1) {
          checklist_all = {
            loaded: false,
            employee: {
              ...data[index].requests[indexSub],
              checklist: { ...data[index].requests[indexSub].checklists[indexCheck] },
              checklists: undefined,
              stage: 2,
            },
            checklist: { ...res.data.checklist },
          }
          dispatch(propsAction.setProps({ checklist_all }))
          ls.set('checklist', '?checklist')
          setDisabledBtn(false)
        } else {
          dispatch(
            modalsAction.alert({
              message: { error: [`${res.message}`] },
              onClose: () => {
                setDisabledBtn(false)
                navigate('../lk')
              },
            })
          )
        }
      })
      .catch(() => {
        dispatch(
          modalsAction.alert({
            message: { error: ['Сервер временно недоступен. Пожалуйста, попробуйте позже'] },
            onClose: () => {
              setDisabledBtn(false)
              navigate('../lk')
            },
          })
        )
      })
  }, [])

  return (
    <Box className={classes.accessStage}>
      {confirm.data?.command && (
        <ModerThreeAccessStageModal
          data={confirm.data}
          confirm={confirm.type}
          updateInfo={updateInfo}
          requestId={confirm.requestId}
          show={moderThreeAccessStageModal}
          onClose={() => setModerThreeAccessStageModal(false)}
        />
      )}

      <Accordion square={false} id="accessStage" expanded={expanded} onChange={handleChangeExAccessStage}>
        <AccordionSummary expandIcon={<Icon className={className} img={img} />}>
          Перевод {stage === 2 && 'на третий этап'}
          {stage === 3 && 'в финал Кубка IRB'}
          {stage === 4 && 'в победители Кубка IRB'}
        </AccordionSummary>
        <AccordionDetails>
          <Box className={className.contentAccordionDetails}>
            <Box mt="3px" mb={1}>
              {data.map((item: N2Approves, index: number) => {
                return (
                  <Box key={`access-stage-three${index}`} className={className.subGroup}>
                    {item.requests.length > 0 && (
                      <Accordion
                        key={`sub_group${index}`}
                        expanded={checkListsTwoSub[`${item.nomination.id}`]}
                        onChange={() =>
                          handleChangeExCheckListsTwoSub(item.nomination.id, !checkListsTwoSub[`${item.nomination.id}`])
                        }
                        square={false}
                      >
                        <AccordionSummary expandIcon={<Icon className={className} img={img} />}>
                          {item.nomination.name}
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box className={className.subGroupAccordionDetailsBox}>
                            {item.requests.map((itemSub: RequestsApproves, indexSub: number) => {
                              return (
                                <Box key={`sub_item${indexSub}`} mt={1} className={classes.accessStageItem}>
                                  <Box className={classes.accessStageName}>
                                    {itemSub.command.name
                                      ? `Команда: «${itemSub.command.name.trim()}»`
                                      : `${itemSub.command.users[0].lastName} ` +
                                        `${itemSub.command.users[0].firstName} ` +
                                        `${itemSub.command.users[0].middleName} `}
                                  </Box>
                                  {itemSub.subdivision && (
                                    <Box className={classes.accessStageSub}>ММ: {itemSub.subdivision.name}</Box>
                                  )}
                                  {itemSub.ball !== null && (
                                    <Box className={classes.accessStageGeneralBall}>
                                      Общие баллы:&nbsp;{itemSub.ball.toFixed(2)}%
                                    </Box>
                                  )}
                                  <Box className={classes.ballList}>
                                    {itemSub.checklists.map((itemCheck: Checklist, indexCheck: number) => {
                                      return (
                                        <Box className={classes.ballListItem}>
                                          <Box className={classes.indexCheckItem}>
                                            <Grid
                                              container
                                              spacing={2}
                                              alignItems="flex-start"
                                              justifyContent="space-between"
                                            >
                                              <Grid item>
                                                <Box className={classes.accessStageNameSub}>
                                                  {itemCheck.moderUser.shortName}
                                                </Box>
                                              </Grid>
                                              <Grid item>
                                                <Box
                                                  className={classes.linkCheckList}
                                                  onClick={() => loadCheckLists(index, indexSub, indexCheck)}
                                                >
                                                  Чек-лист
                                                </Box>
                                              </Grid>
                                            </Grid>
                                          </Box>

                                          <Grid
                                            container
                                            justifyContent="flex-start"
                                            alignItems="flex-start"
                                            spacing={2}
                                          >
                                            <Grid item xs={5}>
                                              <Box className={classes.accessStageBall}>
                                                Баллы:&nbsp;{itemCheck?.percent && itemCheck?.percent.toFixed(2)}%
                                              </Box>
                                            </Grid>
                                            <Grid item xs={5}>
                                              <Grid container wrap="nowrap" alignItems="center" spacing={sm ? 2 : 4}>
                                                <Grid item xs="auto">
                                                  <Grid container wrap="nowrap" alignItems="center" spacing={1}>
                                                    <Grid item xs="auto">
                                                      <img src={img.attentionL1} alt="" width={20} height={20} />
                                                    </Grid>
                                                    <Grid item xs="auto">
                                                      <Box className={classes.crit}>{itemCheck.l1}</Box>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                                <Grid item xs="auto">
                                                  <Grid container wrap="nowrap" alignItems="center" spacing={1}>
                                                    <Grid item xs="auto">
                                                      <img src={img.attentionL2} alt="" width={20} height={20} />
                                                    </Grid>
                                                    <Grid item xs="auto">
                                                      <Box className={classes.crit}>{itemCheck.l2}</Box>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Box>
                                      )
                                    })}
                                  </Box>
                                  {itemSub.finalBtnShow && itemSub.finalStatus === 'NEW' ? (
                                    <Grid item xs={6}>
                                      <Box className={classes.accessStageConfirm}>
                                        <Grid
                                          container
                                          wrap={sm ? 'wrap' : 'nowrap'}
                                          justifyContent={sm ? 'center' : 'flex-start'}
                                          spacing={md ? 1 : 2}
                                        >
                                          <Grid item xs={6} sm="auto">
                                            <Button
                                              variant="contained"
                                              color="secondary"
                                              className={classes.btn}
                                              onClick={() => {
                                                setConfirm({
                                                  data: itemSub,
                                                  requestId: itemSub.id,
                                                  type: 'CONFIRM',
                                                })
                                                setModerThreeAccessStageModal(true)
                                              }}
                                            >
                                              Принять
                                            </Button>
                                          </Grid>
                                          <Grid item xs={6} sm="auto">
                                            <Button
                                              variant="contained"
                                              color="secondary"
                                              className={classes.btnReject}
                                              onClick={() => {
                                                setConfirm({
                                                  data: itemSub,
                                                  requestId: itemSub.id,
                                                  type: 'REJECT',
                                                })
                                                setModerThreeAccessStageModal(true)
                                              }}
                                            >
                                              Отклонить
                                            </Button>
                                          </Grid>
                                          {itemSub.command.users.length > 1 && stage < 4 && (
                                            <Grid item xs={12} sm="auto">
                                              <Button
                                                variant="contained"
                                                color="secondary"
                                                className={classes.btnDisb}
                                                onClick={() => {
                                                  setConfirm({
                                                    data: itemSub,
                                                    requestId: itemSub.id,
                                                    type: 'DISBANDED',
                                                  })
                                                  setModerThreeAccessStageModal(true)
                                                }}
                                              >
                                                Расформировать
                                              </Button>
                                            </Grid>
                                          )}
                                        </Grid>
                                      </Box>
                                    </Grid>
                                  ) : (
                                    <>
                                      {itemSub.finalStatusName !== null && (
                                        <Box className={classes.accessStageStatus}>
                                          <span>Cтатус:</span>&nbsp;{itemSub.finalStatusName}
                                        </Box>
                                      )}
                                    </>
                                  )}
                                </Box>
                              )
                            })}
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    )}
                  </Box>
                )
              })}
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  accessStage: {},
  accessStageItem: {
    marginBottom: 15,
    paddingBottom: 15,
    borderBottom: '1px solid #6C6C6C',
  },
  indexCheckItem: {
    marginBottom: 5,
  },
  accessStageName: {
    fontSize: 16,
    paddingRight: 15,
    fontWeight: 500,
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  accessStageNameSub: {
    fontSize: 14,
    paddingRight: 15,
    fontWeight: 500,
    [down('md')]: {
      fontSize: 14,
    },
    [down('sm')]: {
      fontSize: 13,
    },
  },
  accessStageSub: {
    fontSize: 16,
    paddingTop: 7,
    fontWeight: 500,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  accessStageGeneralBall: {
    fontSize: 16,
    paddingTop: 7,
    fontWeight: 500,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  accessStageBall: {
    fontSize: 15,
    fontWeight: 500,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 14,
    },
    [down('sm')]: {
      fontSize: 13,
    },
  },
  accessStageStatus: {
    fontSize: 16,
    fontWeight: 500,
    color: '#6C6C6C',
    paddingTop: 5,
    '& span': {
      color: palette.secondary.main,
    },
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  accessStageConfirm: {
    marginTop: 15,
    marginBottom: 15,
    [down('md')]: {
      marginTop: 10,
      marginBottom: 10,
    },
  },
  ballList: {
    marginTop: 20,
  },
  ballListItem: {
    marginBottom: 10,
  },
  crit: {
    fontSize: 15,
    fontWeight: 500,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 14,
    },
    [down('sm')]: {
      fontSize: 13,
    },
  },
  linkCheckList: {
    fontSize: 16,
    fontWeight: 600,
    color: '#6C6C6C',
    textDecoration: 'underline',
    cursor: 'pointer',
    transition: '0.3s',
    textDecorationColor: '#6C6C6C!important',
    '-webkit-tap-highlight-color': 'transparent',
    '&:hover': {
      textDecorationColor: 'rgba(255, 255, 255, 0.5)!important',
      color: 'rgba(255, 255, 255, 0.5)!important',
    },
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  btn: {
    fontSize: '16px!important',
    padding: '10px 30px!important',
    minHeight: '35px!important',
    [down('md')]: {
      fontSize: '14px!important',
      padding: '10px 17px!important',
      minHeight: '30px!important',
      minWidth: '120px!important',
    },
    [down('sm')]: {
      fontSize: '12px!important',
      padding: '10px 17px!important',
      minHeight: '25px!important',
      minWidth: '130px!important',
      width: '100%!important',
    },
  },
  btnReject: {
    fontSize: '16px!important',
    padding: '10px 30px!important',
    minHeight: '35px!important',
    color: `${palette.primary.dark}!important`,
    backgroundColor: '#6C6C6C!important',
    '&:hover': {
      color: `${palette.text.primary}!important`,
      backgroundColor: `#5b5b5b!important`,
    },
    [down('md')]: {
      fontSize: '14px!important',
      padding: '10px 17px!important',
      minHeight: '30px!important',
      minWidth: '120px!important',
    },
    [down('sm')]: {
      fontSize: '12px!important',
      padding: '10px 17px!important',
      minHeight: '25px!important',
      minWidth: '130px!important',
      width: '100%!important',
    },
  },
  btnDisb: {
    fontSize: '16px!important',
    padding: '10px 50px!important',
    minHeight: '35px!important',
    [down('md')]: {
      fontSize: '14px!important',
      padding: '10px 20px!important',
      minHeight: '30px!important',
      minWidth: '120px!important',
    },
    [down('sm')]: {
      fontSize: '12px!important',
      padding: '10px 17px!important',
      minHeight: '25px!important',
      minWidth: '145px!important',
      width: '100%!important',
    },
  },
  icon: {},
}))
